import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import React from 'react';
import { useIntl } from 'react-intl';
/**
 * A standardized close button component used across modals and other UI elements.
 * Consumers are responsible for positioning (e.g., wrapping in an absolutely positioned container).
 */
const CloseButton = React.memo(function CloseButton({ onClick, size = 'small', variant = 'text', rounded = true, }) {
    const { $t } = useIntl();
    return (_jsx(Button, { icon: $icon('x'), "aria-label": $t({
            defaultMessage: 'Close',
            id: '7e14727493',
            description: 'Action button label in the Close Button shared UI section',
        }), variant: variant, size: size, rounded: rounded, onClick: onClick }));
});
export default CloseButton;
//# sourceMappingURL=CloseButton.js.map